export const createMorningMonitoring = {
    namespaced: true,

    state: {
        id: null,
        morningMonitoringDate: null
    },

    getters: {
        morningMonitoringDate(state) {
            return state.morningMonitoringDate;
        },

        morningMonitoringId(state) {
            return state.id;
        }
    },

    mutations: {
        setEditMorningMonitoring(state, payload) {
            state.id = payload.id;
            state.morningMonitoringDate = payload.date;
        }
    }
};

export default createMorningMonitoring;
